/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TriggerPasswordResetFlowMutationInput = {
    email: string;
    scope: string;
    clientMutationId?: string | null | undefined;
};
export type TriggerPasswordResetFlowMutationVariables = {
    input: TriggerPasswordResetFlowMutationInput;
};
export type TriggerPasswordResetFlowMutationResponse = {
    readonly triggerPasswordResetFlow: {
        readonly success: boolean | null;
    } | null;
};
export type TriggerPasswordResetFlowMutation = {
    readonly response: TriggerPasswordResetFlowMutationResponse;
    readonly variables: TriggerPasswordResetFlowMutationVariables;
};



/*
mutation TriggerPasswordResetFlowMutation(
  $input: TriggerPasswordResetFlowMutationInput!
) {
  triggerPasswordResetFlow(input: $input) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TriggerPasswordResetFlowMutationPayload",
    "kind": "LinkedField",
    "name": "triggerPasswordResetFlow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TriggerPasswordResetFlowMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TriggerPasswordResetFlowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9b6821729a4c2d4650b8a5c5056596d2",
    "id": null,
    "metadata": {},
    "name": "TriggerPasswordResetFlowMutation",
    "operationKind": "mutation",
    "text": "mutation TriggerPasswordResetFlowMutation(\n  $input: TriggerPasswordResetFlowMutationInput!\n) {\n  triggerPasswordResetFlow(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '6da67522ab6c592199047f2e935ab0fe';
export default node;
